import { Theme } from '@mui/material';

export function getBaseStyle(theme: Theme) {
  return {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderRadius: 2,
    border: 'dashed 3px',
    borderColor: theme.palette.states.focus,
    backgroundColor: theme.palette.background.secondary,
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '120px',
  } as const;
}
